const MOVIES =
{
    title: "Howl's Moving Castle",
    date: "Friday, Oct 16 at 10:35am",
    location: "AMC Shrilington VA",
    image: "https://i.pinimg.com/236x/b6/e7/11/b6e711eb4313d5aa06cb6fa9a3d9a802.jpg"
}

export default MOVIES;